/* eslint-disable arrow-body-style */
import React from "react"
import { Trans, useTranslation } from "next-i18next"
import Link from "next/dist/client/link"
import Image from "next/dist/client/image"

import CourseButton from "../course-button/CourseButton"
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@cs/components/ui/dialog"
import { useUser } from "@cs/components/hooks/useUser"
import styles from "./SurveyDialog.module.scss"
import Earthly from "@cs/public/img/courses/SurveyEarthly.webp"
import { useAccountRedirect } from "@cs/components/hooks/useAccountRedirect"

const SurveyDialog = ({ courseLink, surveyKey }: { courseLink: string; surveyKey: string }) => {
  const { t } = useTranslation("courses")
  const { user } = useUser()
  const { redirectToSignIn } = useAccountRedirect()

  const rememberAction = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem(surveyKey, "true")
    }
  }
  // eslint-disable-next-line max-len
  const surveyLink = `https://docs.google.com/forms/d/e/1FAIpQLSfXMf4mbk3Q9rsvG33-OjiivsoZcg0jIyRNtsVwhxY5UdoDig/viewform?usp=pp_url&entry.1367802495=${user?.email}`

  return (
    <Dialog>
      <DialogTrigger asChild>
        <CourseButton>{t("start-learning")}</CourseButton>
      </DialogTrigger>
      <DialogContent className={styles.content}>
        <div className={styles.image}>
          <Image src={Earthly} alt="Earthly" width={200} height={200} />
        </div>
        <DialogHeader className={styles.header}>
          <DialogTitle className={styles.title}>{t("survey.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className={styles.description}>
          <Trans t={t} i18nKey="survey.description" components={[<strong key="0" />]} />
        </DialogDescription>
        <DialogFooter className={styles.footer}>
          <div className={styles.square}></div>
          {user ? (
            <Link href={courseLink}>
              <a
                onClick={() => {
                  rememberAction()
                  window.open(surveyLink, "_blank")
                }}
                className={`${styles.button}`}
              >
                {t("survey.accept")}
              </a>
            </Link>
          ) : (
            <button onClick={() => redirectToSignIn()} className={`${styles.button}`}>
              {t("survey.accept")}
            </button>
          )}
          <Link href={courseLink}>
            <a onClick={() => rememberAction()} className={`${styles.button}`}>
              {t("survey.skip")}
            </a>
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default SurveyDialog
